import React from 'react';
import PropTypes from 'prop-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import pluralize from 'pluralize';

export default class PageHeader extends React.Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    iconDescription: PropTypes.string,
    iconName: PropTypes.object,
    iconPath: PropTypes.string,
    iconSize: PropTypes.string,
    iconText: PropTypes.string.isRequired,
    iconType: PropTypes.oneOf(['icon', 'img']),
    pageData: PropTypes.shape({
      currentPage: PropTypes.number.isRequired,
      itemCount: PropTypes.number.isRequired,
      itemSingularLabel: PropTypes.string.isRequired,
      pageSize: PropTypes.number.isRequired,
      totalCount: PropTypes.number.isRequired
    })
  };

  displayCount = () => {
    const { currentPage, itemCount, itemSingularLabel, pageSize, totalCount } = this.props.pageData;

    if (totalCount === 0) return `No ${pluralize(itemSingularLabel)} found`;

    const itemCountLabel = pluralize(itemSingularLabel, totalCount, true);

    if (totalCount <= pageSize) return `Displaying ${itemCountLabel}`;

    const lowerBound = (currentPage - 1) * pageSize + 1;
    const upperBound = lowerBound + itemCount - 1;
    return `Displaying <strong>${lowerBound} - ${upperBound}</strong> of <strong>${totalCount}</strong>`;
  };


  render() {
    return (
      <div className={classNames('bg-card shadow p-4 position-relative', this.props.className)}>
        <div className="d-flex justify-content-between align-items-center gap-2">
          <div className="d-flex align-items-stretch gap-2">
            <div className="align-self-center">{this.renderIcon()}</div>
            <h4 className="align-self-center">{this.props.iconText}</h4>
            {this.renderDescription()}
          </div>

          <div>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }

  renderDescription() {
    if (!this.props.iconDescription && !this.props.pageData) return null;
    return (
      <div className="ms-4 border-start ps-4 d-flex align-items-center text-muted">
        {this.props.pageData
          ? this.renderPageCount()
          : <span className="d-none d-md-block">{this.props.iconDescription}</span>
        }
      </div>
    );
  }

  renderPageCount() {
    if (!this.props.pageData) return null;

    return (
      <div className="d-none d-md-block">
        <span className="text-muted" dangerouslySetInnerHTML={{ __html: this.displayCount() }} />
      </div>
    );
  }

  renderIconFromFont = () => {
    return (
      <FontAwesomeIcon icon={this.props.iconName} size={this.props.iconSize} />
    );
  }

  renderIconFromAsset = () => {
    if (this.props.iconPath) {
      return <img src={this.props.iconPath} />;
    }
  }

  renderIcon() {
    switch (this.props.iconType) {
    case 'icon':
      return this.renderIconFromFont();
    case 'img':
      return this.renderIconFromAsset();
    default:
      return null;
    }
  }
}
